import gsap from 'gsap';
/* eslint-disable import/prefer-default-export */

export function complete(resolve, options) {
  if (typeof (options === null || options === void 0 ? void 0 : options.onComplete) === 'function') {
    // eslint-disable-next-line no-unused-expressions
    options === null || options === void 0 ? void 0 : options.onComplete();
  }

  resolve();
}
export function getInitialValues(target, keys) {
  var initials = {};
  keys.forEach(function (key) {
    initials[key] = gsap.getProperty(target, key);
  });
  return initials;
}